import { z } from 'zod'

export const signInSchema = z.object({
  email: z.email('Geçerli bir e-posta girin'),
  password: z.string().min(1, 'Parola gerekli'),
})

export type TSignInSchema = z.infer<typeof signInSchema>

// Giriş rotası search şeması: çıkış sonrası durum + geri-dönüş hedefi.
export const signOutStatusSchema = z.object({
  status: z.enum(['requested', 'signedOut']).optional().catch(undefined),
  redirectTo: z.string().optional().catch(undefined),
})

export const forgotPasswordSchema = z.object({
  email: z.email('Geçerli bir e-posta girin'),
})

export type TForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>

// Güçlü şifre politikası — backend `features/auth/validators.py::is_strong_password` +
// `modules/profile/profile.schemas.ts::newPasswordPolicy` ile birebir aynı kurallar.
const newPasswordPolicy = z
  .string()
  .min(1, 'Şifre alanının doldurulması zorunludur!')
  .min(8, 'Şifre alanı en az 8 karakter uzunluğunda olmalıdır!')
  .max(25, 'Şifre alanı en fazla 25 karakter uzunluğunda olmalıdır!')
  .trim()
  .refine((val) => !/\s/.test(val), {
    message: 'Şifre boşluk karakteri içeremez!',
  })
  .refine((val) => /[a-z]/.test(val), {
    message: 'Şifre en az 1 küçük harf içermelidir!',
  })
  .refine((val) => /[A-Z]/.test(val), {
    message: 'Şifre en az 1 büyük harf içermelidir!',
  })
  .refine((val) => /\d/.test(val), {
    message: 'Şifre en az 1 rakam içermelidir!',
  })
  .refine((val) => /[!@#$%^&*()_\-+={}[\]|:;"'<>,.?/~`]/.test(val), {
    message: 'Şifre en az 1 özel karakter içermelidir!',
  })

export const resetPasswordSchema = z
  .object({
    new_password: newPasswordPolicy,
    confirm_password: z
      .string()
      .min(1, 'Şifre onay alanının doldurulması zorunludur!'),
  })
  .refine((data) => data.new_password === data.confirm_password, {
    message: 'Şifreler eşleşmiyor!',
    path: ['confirm_password'],
  })

export type TResetPasswordSchema = z.infer<typeof resetPasswordSchema>

// Reset rotası search şeması: e-posta linkinden gelen token.
export const resetTokenSearchSchema = z.object({
  token: z.string().optional().catch(undefined),
})
